<template>
    <div>
        <Navbar />
        <MainBanner />
        <Features />
        <WieWirArbeiten />
        <HostingServices />
        <ITConsultancy />
        <AmazingFeatures />
        <OurLovingClients class="bg-white" />
        <IndividuelleAngebote />
        <!-- <WhatsOurClients /> -->
        <Footer />
    </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import Navbar from '../Layouts/Navbar';
import MainBanner from '../HomeThree/MainBanner';
import Features from '../Common/Features';
import WieWirArbeiten from '../Common/WieWirArbeiten';
import ITConsultancy from '../HomeThree/ITConsultancy';
import HostingServices from '../HomeThree/HostingServices';
import AmazingFeatures from '../HomeThree/AmazingFeatures';
import IndividuelleAngebote from '../Common/IndividuelleAngebote';
import OurLovingClients from '../Common/OurLovingClients';
import Footer from '../Layouts/Footer';

export default {
    setup() {
        useHead({
            title: 'Webentwicklung & IT-Dienstleistungen aus Wien | Benovium',
            meta: [
                { name: 'description', content: 'Professionelle Webentwicklung, SEO und Webseiten-Betreuung aus Wien. Ihr direkter Ansprechpartner für moderne Webseiten, Online-Shops und digitale Lösungen.' },
                { property: 'og:title', content: 'Webentwicklung & IT-Dienstleistungen aus Wien | Benovium' },
                { property: 'og:description', content: 'Professionelle Webentwicklung, SEO und Webseiten-Betreuung aus Wien.' },
                { property: 'og:url', content: 'https://benovium.com/' },
            ],
            link: [
                { rel: 'canonical', href: 'https://benovium.com/' }
            ]
        });
    },
    components: {
        Navbar,
        MainBanner,
        Features,
        WieWirArbeiten,
        ITConsultancy,
        HostingServices,
        AmazingFeatures,
        IndividuelleAngebote,
        OurLovingClients,
        Footer,
    }
};
</script>
